import React, { Component } from 'react';

// Form de insumo (productType=5, submódulo Cafetería — ENI-82). Modo alta y edición.
// Emite los datos por this.props.onChangeData(value).
// En edición, la estructura (consumible/unidad/tamaño de paquete) queda deshabilitada:
// el backend la rechaza con 6104 si el insumo ya tiene movimientos, y cambiarla
// rompería la aritmética paquete/remanente.
const CATEGORIES = [
    { value: 'cafeteria', label: 'Cafetería' },
    { value: 'cleaning', label: 'Limpieza' },
    { value: 'packaging', label: 'Packaging' },
    { value: 'other', label: 'Otros' },
];

const UNITS = [
    { value: 'g', label: 'Gramos (g)' },
    { value: 'ml', label: 'Mililitros (ml)' },
    { value: 'unit', label: 'Unidades' },
];

class FormCafeteriaInsumoComponent extends Component {
    constructor(props) {
        super(props);
        const initial = props.initial || {};
        this.state = {
            name: initial.name || '',
            category: initial.category || 'cafeteria',
            isConsumable: initial.isConsumable != null ? Number(initial.isConsumable) === 1 : false,
            baseUnit: initial.baseUnit || 'g',
            packageSize: initial.packageSize != null ? initial.packageSize : '',
            defaultConsumption: initial.defaultConsumption != null ? initial.defaultConsumption : '',
            stock: initial.stock != null ? initial.stock : '',
            minStock: initial.minStock != null ? initial.minStock : '',
            cost: initial.cost != null ? initial.cost : '',
            barCode: initial.barCode || '',
            description: initial.description || '',
            // Publicaciones de ML. Un insumo se puede vender por ML en PAQUETES ENTEROS (bolsa de
            // café cerrada): el stock que ML ofrece es el de paquetes cerrados. Solo en edición —
            // el alta todavía no tiene código con el cual vincular.
            externalIds: Array.isArray(initial.externalItems) ? initial.externalItems : [],
        };
    }

    addExternalId = () => {
        // Vacío y no el string "New": el form viejo de juegos arranca con "New" y por eso hay
        // filas basura en external_item que parecen un vínculo cargado pero no sincronizan nada.
        this.setState({ externalIds: [...this.state.externalIds, ''] });
    }

    handleExternalIdChange = (index, event) => {
        const externalIds = [...this.state.externalIds];
        externalIds[index] = event.target.value;
        this.setState({ externalIds });
    }

    deleteExternalId = (index) => {
        const externalIds = [...this.state.externalIds];
        externalIds.splice(index, 1);
        this.setState({ externalIds });
    }

    handleChange = (e) => {
        const { name, type, value, checked } = e.target;
        this.setState({ [name]: type === 'checkbox' ? checked : value });
    }

    isValid = () => {
        if (this.state.name.trim() === '') {
            return false;
        }
        if (this.state.isConsumable && !(Number(this.state.packageSize) > 0)) {
            return false;
        }
        return true;
    }

    submit = () => {
        if (!this.isValid()) {
            alert('Completá el nombre (y el contenido del paquete si es consumible).');
            return;
        }
        const editMode = !!this.props.editMode;
        const payload = {
            name: this.state.name,
            category: this.state.category,
            minStock: this.state.minStock === '' ? null : Number(this.state.minStock),
            cost: this.state.cost === '' ? 0 : Number(this.state.cost),
            barCode: this.state.barCode,
            description: this.state.description,
        };
        if (this.state.defaultConsumption !== '') {
            payload.defaultConsumption = Number(this.state.defaultConsumption);
        }
        if (!editMode) {
            // La estructura solo se define en el alta (inmutable con historia — 6104).
            payload.isConsumable = this.state.isConsumable;
            payload.baseUnit = this.state.baseUnit;
            payload.packageSize = this.state.isConsumable ? Number(this.state.packageSize) : 1;
            payload.stock = this.state.stock === '' ? 0 : Number(this.state.stock);
        } else {
            // Se filtran los vacíos: una fila en blanco guardada como vínculo no sincroniza nada
            // y encima queda como si el producto estuviera publicado.
            payload.externalItems = this.state.externalIds
                .map((id) => String(id || '').trim())
                .filter((id) => id !== '');
        }
        this.props.onChangeData(payload);
    }

    field(label, name, type = 'text', extra = {}) {
        return (
            <div className="form-group">
                <label>{label}</label>
                <input
                    type={type}
                    name={name}
                    className="form-control"
                    value={this.state[name]}
                    onChange={this.handleChange}
                    {...extra}
                />
            </div>
        );
    }

    render() {
        const editMode = !!this.props.editMode;
        return (
            <div className="card card-small mb-4">
                <div className="card-body p-4">
                    <h6 className="text-uppercase text-muted">Insumo</h6>
                    <div className="row">
                        <div className="col-md-6">{this.field('Nombre *', 'name')}</div>
                        <div className="col-md-3">
                            <div className="form-group">
                                <label>Categoría</label>
                                <select name="category" className="form-control" value={this.state.category} onChange={this.handleChange}>
                                    {CATEGORIES.map((c) => (<option key={c.value} value={c.value}>{c.label}</option>))}
                                </select>
                            </div>
                        </div>
                        <div className="col-md-3">{this.field('Costo por paquete', 'cost', 'number')}</div>
                    </div>

                    <div className="row">
                        <div className="col-md-4">
                            <div className="form-group">
                                <label className="d-block">Tipo</label>
                                <label>
                                    <input type="checkbox" name="isConsumable" checked={this.state.isConsumable} onChange={this.handleChange} disabled={editMode} />
                                    {' '}Consumible por receta (café, leche…) — se descuenta al vender
                                </label>
                                {editMode && (
                                    <small className="form-text text-muted">La estructura no se cambia después del alta.</small>
                                )}
                            </div>
                        </div>
                        {this.state.isConsumable && (
                            <React.Fragment>
                                <div className="col-md-3">
                                    <div className="form-group">
                                        <label>Unidad base</label>
                                        <select name="baseUnit" className="form-control" value={this.state.baseUnit} onChange={this.handleChange} disabled={editMode}>
                                            {UNITS.map((u) => (<option key={u.value} value={u.value}>{u.label}</option>))}
                                        </select>
                                    </div>
                                </div>
                                <div className="col-md-3">{this.field('Contenido del paquete *', 'packageSize', 'number', { disabled: editMode, placeholder: 'ej: 1000' })}</div>
                                <div className="col-md-2">{this.field('Consumo típico', 'defaultConsumption', 'number', { placeholder: 'ej: 16' })}</div>
                            </React.Fragment>
                        )}
                    </div>

                    <div className="row">
                        {!editMode && (
                            <div className="col-md-3">{this.field('Paquetes iniciales', 'stock', 'number')}</div>
                        )}
                        <div className="col-md-3">{this.field('Mínimo (paquetes)', 'minStock', 'number')}</div>
                        <div className="col-md-6">{this.field('Código de barras', 'barCode')}</div>
                    </div>
                    <div className="form-group">
                        <label>Descripción</label>
                        <textarea name="description" className="form-control" rows="2" value={this.state.description} onChange={this.handleChange} />
                    </div>

                    {editMode && (
                        <div className="form-group">
                            <label className="d-block">Identificadores de ML</label>
                            <small className="form-text text-muted mb-2">
                                Para vender el paquete cerrado por MercadoLibre. El stock publicado son los
                                paquetes cerrados: el que está abierto en la cafetería no se ofrece.
                            </small>
                            {this.state.externalIds.map((externalId, index) => (
                                <div className="form-row" key={index}>
                                    <div className="form-group col-md-8">
                                        <input
                                            type="text"
                                            className="form-control"
                                            placeholder="MLU123456789"
                                            value={externalId}
                                            onChange={(event) => this.handleExternalIdChange(index, event)}
                                        />
                                    </div>
                                    <div className="form-group col-md-4">
                                        <button type="button" className="mb-2 btn btn-outline-danger mr-2" onClick={() => this.deleteExternalId(index)}>X</button>
                                    </div>
                                </div>
                            ))}
                            <button type="button" className="mb-2 btn btn-outline-dark mr-2" style={{ width: '160px' }} onClick={this.addExternalId}>
                                Agregar Id de ML
                            </button>
                        </div>
                    )}

                    <button type="button" className="btn btn-accent" disabled={this.props.disabled} onClick={this.submit}>
                        {editMode ? 'Guardar' : 'Crear insumo'}
                    </button>
                </div>
            </div>
        );
    }
}

export default FormCafeteriaInsumoComponent;
